const SET_REMOTE_IFRAME = 'SET_REMOTE_IFRAME';

export default {
  SET_REMOTE_IFRAME
};
